<template>
  <div class="tutorial-selection">
    <v-card outlined class="mx-auto px-5 py-7" elevation="2">
      <v-simple-table dense fixed-header height="450px" class="text-subtitle">
        <template v-slot:default>
          <thead>
            <tr>
              <th>Name</th>
              <th>Tutor</th>
              <th>Format</th>
              <th>Begin at</th>
              <th>End at</th>
              <th>Selected</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="tutorial in tutorials"
              :key="tutorial.id"
              @click="selectedId = tutorial.id"
            >
              <td>{{ tutorial.name }}</td>
              <td>{{ tutorial.responsible_tutor }}</td>
              <td v-if="tutorial.room">offline</td>
              <td v-else>online</td>
              <td>{{ tutorial.start }}</td>
              <td>{{ tutorial.end }}</td>
              <td>
                <v-checkbox
                  dense
                  color="primary"
                  :value="selectedId == tutorial.id"
                ></v-checkbox>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-btn
        block
        color="tertiary"
        class="mt-5 white--text"
        @click="updateSelectedTutorials"
        >Auswählen</v-btn
      >
    </v-card>
  </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
  date() {
    return {
      checked: true,
    };
  },
  setup(props, { root }) {
    const tutorials = ref([]);
    const selectedId = ref(root.$route.params.tutorialId || -1);

    root.$axios.get("tutorials").then((req) => (tutorials.value = req.data));

    const updateSelectedTutorials = () => {
      if (selectedId.value == -1) {
        return;
      }
      root.$axios
        .post("tutorials/subscribed/", {
          id: selectedId.value,
        })
        .then(() => {
          root.$router.push({ name: "tutorials.my-tutorial" });
        });
    };

    return {
      tutorials,
      selectedId,
      updateSelectedTutorials,
    };
  },
});
</script>

<style>
.submit {
  margin-top: 5px;
}

button {
  background-color: transparent;
}

input[type="checkbox"],
input[type="radio"] {
  width: 14px !important;
  height: 14px !important;
  clip: auto !important;
}

table th {
  width: initial;
}

.v-input--checkbox.v-input--dense {
  margin-top: 0;
}

.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.v-input--dense > .v-input__control > .v-input__slot {
  margin-bottom: 0;
}

.v-input__slot {
  margin-bottom: 0;
}

table td {
  vertical-align: middle;
}
</style>

<style>
.v-messages {
  min-height: 0 !important;
  min-width: 0 !important;
}
</style>
